import React, { useContext, useState, useEffect } from 'react';
import Form from '../../../Form/Form';
import { IMPERSONATION_KEY, UserContext } from '../../../../Context/UserContext/UserContext';
import { useStyles } from './ImpersonationForm.styles';
import { useIntl } from 'react-intl';
import { Hidden, Divider, Box } from '@material-ui/core';
import { useFormField } from '../../../Form/FormField';
import { useDispatch, useSelector } from "react-redux";
import UserSevicesApi from "../../../../Redux/Actions/UserAction";
import { useSnackbar } from "notistack";
export const ImpersonationForm = () => {
  const { impersonateUser, userImpersonation } = useContext(UserContext);
  const { formatMessage } = useIntl();
  const dispatch: any = useDispatch();
  const [options, setOptions] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const { userList, apiToken, inpersonateList } = useSelector((state: any) => ({
    userList: state.UserReducer.userList,
    apiToken: state?.UserReducer?.apiToken,
    inpersonateList: state?.UserReducer?.inpersonateList
  }));


  // useEffect(() => {
  //   if (userImpersonation === undefined && supportInvitation === undefined) {
  //     api.getImpersonationUsers().then((result) => {
  //       if (abortController.current.signal.aborted) {
  //         return;
  //       }
  //       setOptions(result.users);
  //     });
  //   }
  // }, [api, abortController, userImpersonation, supportInvitation]);
  useEffect(() => {
   if(apiToken){
    dispatch(UserSevicesApi.InpersonateUserData(apiToken, enqueueSnackbar))
   }
  }, [])
  useEffect(() => {
    console.log(inpersonateList,"ffnflflfmsfzckl")
    let filterUserList = inpersonateList?.filter((val) => !val?.isDeleted && val?.b2CAccountId != null)
    let userListData = filterUserList?.map((val) => {
      return {
        label: `${val?.firstName} ${val?.lastName} <${val?.email}>`,
        value: val?.email
      }
    })
    setOptions(userListData)
  }, [inpersonateList])

  const impersonationField = useFormField({
    label: formatMessage({ id: 'form.impersonation' }),
    name: 'email',
    required: false,
    type: 'single-select',
    options: options,
  });

  const classes = useStyles();

  return (
    <>
      <div className={classes.mobile}>
        <Form
          className={classes.root}
          submit={(form, onSuccess) => {
            const email: any = form.email as string | undefined;
            let finddata = inpersonateList?.filter((item: any) => item?.email == email)
            impersonateUser(finddata[0])
            onSuccess();
            return Promise.resolve();
          }}
          singleField={impersonationField}
        ></Form>
      </div>
      {/* <Hidden mdUp>
          <Divider />
        </Hidden> */}
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <Divider />
      </Box>
    </>
  );
};
